export default function SkeletonCard() {
  return (
    <div className="overflow-hidden rounded-lg border border-background-300/70 bg-background-50">
      <div className="aspect-[2/3] w-full animate-pulse bg-background-200" />
      <div className="flex flex-col gap-2 p-3.5">
        <div className="h-4 w-3/4 animate-pulse rounded bg-background-200" />
        <div className="h-3 w-1/2 animate-pulse rounded bg-background-200" />
        <div className="h-3 w-full animate-pulse rounded bg-background-200" />
        <div className="h-3 w-2/3 animate-pulse rounded bg-background-200" />
      </div>
    </div>
  );
}